<template>
  <div class="w-full flex flex-col break-words bg-white shadow-lg rounded-2xl bg-clip-border border p-4">
    <div class="flex flex-row flex-wrap">
      <div class="w-full flex flex-col">
        <p class="mb-0 font-sans font-light leading-normal text-sm">
          {{ label }}
        </p>
        <h5 class="mb-0 font-bold text-xl mt-2">
          {{ value }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stats-card",
  props: {
    label: String,
    value: [String, Number],
  },
};
</script>
